import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S8};
`
